import styled from 'styled-components';
import { Card } from '@interstate/components/Card';

/** Wraps the stacked address cards so adjacent ones share a fused border. */
export const AddressList = styled.div`
    .MuiCard-root {
        /* 1.142rem matches the legacy address card padding (16px at 14px base font) */
        padding: 1.142rem;
        /* Remove bottom border/radius only when a second card immediately follows */
        &:has(+ .MuiCard-root) {
            border-bottom: none;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
        }
        /* Remove top radius from billing card when it follows the primary card */
        & + .MuiCard-root {
            border-top-left-radius: 0;
            border-top-right-radius: 0;
        }
        .card-header-content-container {
            padding: 0;
        }
    }
`;

/** Card shell for address cards. The edit variant uses a light grey background. */
export const AddressCard = styled(Card)<{ $editing?: boolean }>`
    ${({ $editing }) => ($editing ? 'background: #F4F4F4 !important;' : '')}
`;

export const CardHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
`;

export const ButtonGroup = styled.div`
    display: flex;
    gap: 0.5rem;
`;

export const AddressContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
`;

export const AddressCopyContainer = styled(AddressContent)`
    margin-bottom: 1rem;
`;

export const CheckBoxRow = styled.div`
    display: flex;
    align-items: center;
    gap: 0.25rem;
`;

export const PopoverRow = styled.div`
    display: flex;
    flex-direction: column;
    /* Negative margin compensates for the popover trigger button's internal padding */
    margin-right: -0.375rem;
`;
